<template>
  <div>
    <!-- TABELA -->
    <v-layout v-if="!isNewContract" wrap row xs12>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Pesquisar" single-line hide-details></v-text-field>
        <v-spacer></v-spacer>
        <!-- <v-tooltip bottom> -->
        <v-btn fab dark color="primary" class="mb-2" @click.prevent="addNewContract();" :loading="loading">
          <v-icon dark>add</v-icon>
        </v-btn>
        <!-- <span>Tooltip</span>
        </v-tooltip> -->
      </v-toolbar>
      <v-data-table :headers="headers" :search="search" rows-per-page-text="Registros por Página"
        :rows-per-page-items="[10, 30, 50, 100]" :items="contracts" :pagination.sync="pagination" item-key="contractCode" class="elevation-1" style="width: 100%"
        :loading="loading">
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.contractCode }}</td>
          <td class="text-xs-center">{{ props.item.company.socialName || null }}</td>
          <td class="text-xs-center">{{ props.item.client.socialName || props.item.client.name }}</td>
          <td class="text-xs-center" v-if="!props.item.situation.status">
            <v-chip small class="font-weight-light"></v-chip>
          </td>
          <td class="text-xs-center" v-else>
            <v-chip small class="font-weight-light" :color="props.item.situation.statusColor">
              {{props.item.situation.status}} </v-chip>
          </td>
          <td class="justify-center layout px-0"
            :title=" props.item.status=='Aprovado'? 'Visualizar Contrato':'Editar Contrato'">
            <v-btn color="info" flat icon round>
              <v-icon @click="editItem(props.item)">
                {{ props.item.status=="Aprovado" ? 'visibility': 'edit'}}
              </v-icon>
            </v-btn>

          </td>
        </template>
        <template slot="pageText" slot-scope="props">
          {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
        <template slot="no-data">
          <strong> {{footerDynamicText}} </strong>
        </template>
        <div slot="no-results" :value="true">
          <h3 class="text-xs-center">{{emptySearchText}} "{{ search }}".</h3>
        </div>
      </v-data-table>
    </v-layout>
    <!-- TABELA -->

    <!-- NOVO CONTRATO -->
    <v-layout v-else wrap row>
      <!-- TOOLBAR -->
      <v-toolbar dark color="primary">
        <v-btn icon dark @click.prevent="cancelNewContract();" title="Cancelar">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{titlePageContract}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn @click.prevent="importBudget" v-if="!accessInpustOfPage" title="Importar orçamento" color="primary"
            small depressed>
            Importar Orçamento
            <v-icon right>get_app</v-icon>
          </v-btn>
          <v-divider vertical class="ml-2 mr-2" v-if="!accessInpustOfPage" inset dark></v-divider>
          <v-btn @click.prevent="saveInEdition" v-if="!contractFinalized" title="Salvar Contrato" color="primary" small
            depressed>
            Salvar
            <v-icon right>save</v-icon>
          </v-btn>
          <v-divider vertical class="ml-2 mr-2" v-if="!contractFinalized" inset dark></v-divider>
          <v-btn @click.prevent="sendContract" v-if="!contractFinalized" title="Enviar para Aprovação" color="primary"
            small depressed>
            Enviar Para Aprovação
            <v-icon right>send</v-icon>
          </v-btn>
          <v-divider vertical class="ml-2 mr-2" inset dark></v-divider>
          <v-btn @click.prevent="download" title="Download Contrato" color="primary" small depressed>
            Download Contrato
            <v-icon right>cloud</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <!-- TOOLBAR -->

      <!-- INPUTS -->
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12>
            <v-container fluid grid-list-lg>
              <v-alert :value="alert" :color="alertType" dismissible class="mb-3">
                {{msgAlert}}
              </v-alert>
              <v-layout justify-space-between row wrap>
                <v-flex xs12 sm6 py-0>
                  <v-autocomplete label="Empresa" :disabled="accessInpustOfPage" v-model="contract.company"
                    item-value="_id" :items="companies" :item-text="companyText" return-object dense flat box
                    no-data-text="Nenhuma empresa encontrada">
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 py-0>
                  <v-autocomplete label="Cliente (Contratante)" :disabled="accessInpustOfPage" v-model="contract.client"
                    :items="clients" item-value="_id" :item-text="clientText" return-object dense flat box
                    no-data-text="Nenhum cliente encontrado">
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md4 py-0>
                  <!-- Esse dado é a soma dos valores do setor? -->
                  <v-text-field v-model="contract.amount" :disabled="accessInpustOfPage" label="Valor do Contrato (Mês)"
                    box>
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4 py-0>
                  <v-text-field v-model="contract.startDate" :disabled="contractFinalized" label="Início do Periodo"
                    type="date" box></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 py-0>
                  <v-text-field v-model="contract.endDate" :disabled="contractFinalized" label="Fim do Periodo"
                    type="date" box></v-text-field>
                </v-flex>
              </v-layout>
              <v-divider class="mt-3"></v-divider>
            </v-container>
          </v-flex>
          <!-- INPUTS -->

          <!-- SETORES -->
          <v-flex xs12>
            <v-container fluid grid-list-xl>
              <v-layout row justify-end>
                <v-flex xs12>
                  <h2>Setores</h2>
                </v-flex>
                <v-btn fab dark small color="primary" class="mb-2" :disabled="accessInpustOfPage"
                  @click.prevent="addNewDepartament">
                  <v-icon dark>add</v-icon>
                </v-btn>
              </v-layout>
            </v-container>
          </v-flex>
          <!-- GRID DE CARDS DE SETOR -->
          <v-flex xs12>
            <v-container fluid grid-list-xl>
              <v-layout row wrap>
                <v-flex xs12 sm6 md4 v-for="(department, i) in contract.departments" :key="department._id">
                  <v-list two-line light class="py-0 elevation-2">
                    <v-list-tile>
                      <v-list-tile-content class="descoration" @click="editDepartment(i, department)">
                        <v-list-tile-title v-if="department.lastName">
                          {{department.name +"-"+department.lastName}}
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{department.numberOfEmployees>0?department.numberOfEmployees+' funcionário(s)': "Nenhum Funcionário Cadastrado"}}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-divider vertical inset></v-divider>
                      <v-list-tile-action class="descoration" @click="openDialogConfirm(department)">
                        <v-icon color="red" :disabled="accessInpustOfPage" class="pr-2">delete_forever</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
              <v-divider class="mt-5"></v-divider>
            </v-container>
            <alert-delete ref="alertDeleteDepartment" @deleteItem="removeDepartment"></alert-delete>


            <!-- GRID DE CARDS DE SETOR -->


          </v-flex>
          <!-- SETORES -->
          <!-- DOCUMENTOS -->
          <v-flex xs12>
            <v-container fluid grid-list-xl>
              <v-layout row wrap class="pt-4">
                <v-flex xs12>
                  <v-layout row justify-end>
                    <v-flex xs12>
                      <h2>Documentos</h2>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <documents ref="docspdf" :contractDocuments="contract.contractDocuments"
                    :disableActions="contractFinalized" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
          <!-- DOCUMENTOS -->
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- NOVO CONTRATO -->
    <!-- DIALOG EDIÇÃO DE SETOR -->
    <v-layout row justify-center>
      <v-dialog v-model="dialogDepartment" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="primary" class="elevation-1">
            <v-btn icon dark @click="closeDialogDepartment" title="Cancelar">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{titlePageDepartment}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn @click="saveDepartment" title="Salvar Setor" color="primary" small depressed>
                Salvar
                <v-icon right>save</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-layout row wrap px-5>
            <v-flex xs12>
              <department @chengedSector='sendAddress' :finalizedContract="accessInpustOfPage"
                :contractHaveBudgetImported="contract.budgetImported"
                :contractDontHaveBudgetButIsFinished="contractFinalized" ref="departmentForm" />
            </v-flex>
            <v-flex xs12 mt-5 mb-3>
              <tables ref="materialTables" :contractFinished="accessInpustOfPage" />
            </v-flex>

          </v-layout>

        </v-card>
      </v-dialog>
    </v-layout>
    <!-- DIALOG EDIÇÃO DE SETOR -->

    <!-- DIALOG LOADING -->
    <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Carregando
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- DIALOG LOADING -->

    <!-- DIALOG IMPORTAÇÃO DE ORÇAMENTO -->
    <v-dialog v-model="dialogImportBudget" width="80%">
      <v-card>
        <v-data-table :headers="budgetHeaders" :search="search" rows-per-page-text="Registros por Página"
          :rows-per-page-items="[5, 10, 30, 50]" :items="budgets" class="elevation-1" style="width: 100%"
          :loading="loading">
          <template slot="items" slot-scope="props">
            <tr @click="selectBudget(props.item)" class="clickable">
              <td class="text-xs-center">{{ props.item.code }}</td>
              <td class="text-xs-center">{{ props.item.company.socialName || null }}</td>
              <td class="text-xs-center">{{ props.item.tradingFloor }}</td>
              <td class="text-xs-center">{{ props.item.process }}</td>
              <td class="text-xs-center">{{ props.item.client.socialName || props.item.client.name }}</td>
              <td class="text-xs-center">
                {{ utilFormatter.formatDateBR(props.item.dateOfTheTradingFloor.substr(0, 10)) }}
              </td>
            </tr>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
          <template slot="no-data">
            <strong> {{footerDynamicText}} </strong>
          </template>
          <div slot="no-results" :value="true">
            <h3 class="text-xs-center">{{emptySearchText}} "{{ search }}".</h3>
          </div>
        </v-data-table>
      </v-card>
    </v-dialog>
    <!-- DIALOG IMPORTAÇÃO DE ORÇAMENTO -->

  </div>
</template>

<script>
  // SERVICES //
  import AnalyticalWorksheetService from "../service/AnalyticalWorksheetService.js";
  import BudgetService from "../service/BudgetService.js";
  import ContractService from "../service/ContractService.js";
  import CompanyService from "../service/CompanyService.js";
  import PersonService from "../service/PersonService.js";
  import UserService from "../service/UserService.js";
  import UtilService from "../service/UtilService.js";
  import TypesOfSituations from "../utils/TypesOfSituations.js";
  import UtilFormatter from "../utils/UtilFormatter.js";
  import MessageFormatterUtil from '../utils/MessageFormatterUtil.js'
  import SystemConfigurationService from '../service/SystemConfigurationService';
  import Headers from '../data/headers/ContractHeaders';
  import CityService from "../service/CityService.js";

  // COMPONENTES
  import AlertDelete from "../components/AlertDelete"
  import Department from "../components/contract/department/Department";
  import Documents from '../components/contract/Uploads/UploadPdf';
  import Tables from '../components/contract/department/Tables';



  export default {
    components: {
      AlertDelete,
      Department,
      Documents,
      Tables
    },

    data() {
      return {
        pagination: {
          sortBy: 'contractCode',
          descending:true
        },
        firstAccess: true,
        dialogLoading: false,
        dialogImportBudget: false,
        dialogDepartment: false,
        utilFormatter: UtilFormatter,
        isNewContract: true,
        isEditing: false,
        isSearchingAddress: false,

        // ALERT //
        msgAlert: "",
        alertType: "",
        alert: false,

        // CAMPOS //
        cities: [],
        cep: '',
        contract: {
          contractDocuments: [],
          client: {
            address: {}
          },
          situation: {},
          company: {
            address: { // Endereço
              cep: '',
              addressType: '', // Logradouro
              number: '',
              district: '',
              complement: '',
              city: '',
              state: '',
            },
          },
          departments: []
        },
        companies: [],
        clients: [],
        users: [],
        sheetRemovable: {},
        situations: [],
        removeDialog: false,
        budgets: [],
        departmentIndex: -1,

        // TABELA //
        loading: false,
        contracts: [],
        emptyRecordsText: "Nenhum registro encontrado",
        emptySearchText: "Nenhum registro encontrado para",
        search: "",
        editingSheet: {},
        //Headers
        headers: [],
        department: {
          professionalCategory: {}
        },
        materials: {
          consumables: {
            items: []
          },
          equipments: {
            items: []
          },
          uniformsAndEPIs: {
            items: []
          },
          utensils: {
            items: []
          }
        },
        editDepartmentItem: false,
        sectorType: "SEDE",
        contractFinalized: false,
        budget: {}
      };

    },

    methods: {
      getHeaders() { // esse metodo busca os cabeçalhos de um arquivo externo 
        this.headers = Headers.getHeaders()
        this.budgetHeaders = Headers.getBudgetHeaders()
      },

      init() {
        this.alert = false;
        this.contract = {
          contractDocuments: [],
          client: {
            address: {}
          },
          budgetImported: false,
          situation: {},
          company: {
            address: { // Endereço
              cep: '',
              addressType: '', // Logradouro
              number: '',
              district: '',
              complement: '',
              city: '',
              state: '',
            },
          },
          departments: []
        };

        this.$refs.materialTables.resetAll();
        this.loading = false;
        this.isEditing = false;
        this.dialogLoading = true;
        this.isNewContract = false;
        this.dialogLoading = false;
        this.contractFinalized = false;
        this.budgetImported = false;
        this.editingSheet = {}
        this.findAllContracts()
      },

      companyText: item =>
        `${item.socialName} - ${item.fantasyName}`,

      clientText: item => {
        return item.isLegalPerson ?
          `${item.socialName} - ${item.fantasyName}` :
          `${item.name} - ${item.cpf}`;
      },

      amountCalculate(item) {
        let amount = 0;
        if (this.depreciation == "true") {
          amount = (item.quantity * item.value * (item.lifetime / 100));
        } else {
          amount = item.quantity * item.value / item.lifetime;
        }
        return amount;
      },

      async addNewContract() {
        this.dialogLoading = true
        if (this.firstAccess) {
          await this.fillCompaniesTable();
          await this.fillClientsTable();
          await this.fillUsersTable();
          this.firstAccess = false
          this.dialogLoading = false
          this.isNewContract = true
        } else {
          this.dialogLoading = false
          this.isNewContract = true
        }
      },

      cancelNewContract() {
        this.init()
      },

      async findAllContracts() {
        try {
          this.loading = true
          this.contracts = await ContractService.findAll();
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false
        }
      },

      async fillCompaniesTable() {
        try {
          this.companies = await CompanyService.getCompaniesForSpecificData();
        } catch (error) {
          console.log(error);
        }
      },

      async fillClientsTable() {
        try {
          this.clients = await PersonService.getAll();
        } catch (error) {
          console.log(error);
        }
      },

      async fillUsersTable() {
        try {
          this.users = await UserService.getAll();
        } catch (error) {
          console.log(error);
        }
      },

      async importBudget() {
        try {
          this.dialogLoading = true
          this.loading = true
          this.budgets = await BudgetService.getAllApproved();
          this.dialogImportBudget = true;
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false
          this.dialogLoading = false
        }
      },

      showAlert(message, type) {
        this.msgAlert = message;
        this.alertType = type;
        this.alert = true;
      },

      editItem(item) {
        this.isEditing = true;
        this.contract = Object.assign({}, item);
        this.verifyStatus();
        this.addNewContract();
      },
      async budgetInUse() {
        if (this.contract.budgetImported) {
          this.budget.inUse = true
          await BudgetService.edit(this.budget);
        }
      },
      async saveInEdition() {
        if (this.contract.situation.status != 'Aguardando Revisão do Operacional' && this.contract.situation.status !='Aprovado' ) {
          this.budgetInUse()
          this.contract.situation.status = 'Em Edição';
          this.save();
        }
      },
      sendContract() {
        //validar se todos os dados dos Setores e do contrato estão preenchidos

        this.contract.situation.status = 'Aguardando Revisão do Operacional'
        this.contract.situation.statusColor = "info"
        this.budgetInUse()
        this.save();
      },

      async save() {
        this.dialogLoading = true
        // this.contract.contractDocuments = this.$refs.docspdf.saveAllDocuments()
        let errors = ContractService.validade(this.contract)
        if (errors) {
          this.showAlert(MessageFormatterUtil.formatErrorMessage(errors), "error")
          this.dialogLoading = false
          return
        }
        try {

          if (this.isEditing) {
            await ContractService.update(this.contract);
            this.showAlert("Registro alterado com sucesso", "success");
          } else {
            await ContractService.create(this.contract);
            this.showAlert("Registro salvo com sucesso", "success");
          }
        } catch (error) {
          this.showAlert("Erro ao salvar o contrato", "error");
          console.log(error);
        } finally {
          this.dialogLoading = false
        }
        this.init()
      },


      async selectBudget(budget) {


        this.dialogImportBudget = false
        this.dialogLoading = true
        budget = await BudgetService.findComplete(budget._id)
        this.contract = await ContractService.budgetToContract(budget, this.contract)
        this.contract.budgetImported = true
        this.budget = JSON.parse(JSON.stringify(budget))
        this.dialogLoading = false
      },

      editDepartment(index, item) {
        this.editDepartmentItem = true
        this.$refs.departmentForm.editDepartment(item)
        this.$refs.materialTables.loadTables(item.materials)
        this.departmentIndex = index
        this.dialogDepartment = true
      },
      openDialogConfirm(department) {
        this.$refs.alertDeleteDepartment.openDialog(department);
      },
      removeDepartment(item) {
        if (!this.accessInpustOfPage) {
          const index = this.contract.departments.indexOf(item)
          this.contract.departments.splice(index, 1)
        }

      },

      async saveDepartment( /* department */ ) {
        let dep = this.$refs.departmentForm.saveDepartment()
        this.department = dep
        this.department.materials = await this.$refs.materialTables.save()
        if (this.editDepartmentItem) {
          this.contract.departments[this.departmentIndex] = this.department
          this.editDepartmentItem = false
        } else {
          this.contract.departments.push(this.department)
        }
        this.closeDialogDepartment()
      },
      sendAddress() {
        this.$refs.departmentForm.setAddress(this.contract.client.address);
      },

      addNewDepartament() {
        this.dialogDepartment = true;
      },

      closeDialogDepartment() {
        this.$refs.departmentForm.resetDepartment()
        this.materials = {
          consumables: {
            items: []
          },
          equipments: {
            items: []
          },
          uniformsAndEPIs: {
            items: []
          },
          utensils: {
            items: []
          }
        }
        this.$refs.materialTables
        this.departmentIndex = -1
        this.dialogDepartment = false
        this.editDepartmentItem = false
      },
      async download() {
        // let sheet = await BudgetService.download(this.contract._id)

        // var blob = new Blob([sheet], {
        //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"
        // });
        // var url = window.URL.createObjectURL(blob)
        // window.open(url);
      },
      verifyStatus() {
        if (this.contract.status == 'Aprovado') {
          this.contractFinalized = true
        }
      },

      // DOCMENTS PDF
      /*  setDocments(doc) {
         this.$refs.docspdf.setDocuments(doc)
       } */

    },

    computed: {
      footerDynamicText() {
        let text = this.loading ? this.loadingRecordsText : this.emptyRecordsText;
        return text;
      },
      formTitle() {
        return this.isEditing ? "Editar Item" : "Novo Item";
      },
      accessInpustOfPage() {
        if (this.contract.budgetImported || this.contractFinalized) {
          return true;
        } else {
          return false
        }
      },
      titlePageContract() {
        if (this.contract.status == 'Aprovado') {
          return "Contrato"
        } else return this.isEditing ? 'Editar Contrato' : "Novo Contrato"

      },
      titlePageDepartment() {
        if (this.contract.status == 'Aprovado' || this.contract.budgetImported) {
          return "Setor"
        } else return this.isEditing ? 'Editar Setor' : "Novo Setor"
      },
    },
    beforeMount() {
      this.getHeaders();

    },
    mounted() {
      this.init();
    },
    beforeDestroy() {
      this.firstAccess = true;
    }
  };

</script>

<style>
  .descoration {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Contract.vue